// Single source of truth for tracking severity highlight colours, shared across the flex-layout
// setup-overview table, the report car-setup table, and the assembly parts table.
// Colours are applied as inline styles (not tailwind classes) so they survive in every consumer's
// build — a shared package cannot rely on each consumer's tailwind `content` scanning it.

export type TrackingHighlight = "warning" | "critical" | "change" | null;

export const TRACKING_HIGHLIGHT_COLORS = {
  warning: { background: "#fbbf24", foreground: "#374151" }, // amber-400 on gray-700
  critical: { background: "#ef4444", foreground: "#ffffff" }, // red-500 on white
  change: { background: "#fef08a", foreground: "#374151" }, // yellow-200 on gray-700
} as const;

/** Background hex for a highlight (undefined when none) — e.g. to compute an accessible text colour. */
export const getTrackingHighlightHex = (highlight: TrackingHighlight): string | undefined =>
  highlight ? TRACKING_HIGHLIGHT_COLORS[highlight].background : undefined;

/** Inline background + readable foreground style for a highlight (undefined when none). */
export const getTrackingHighlightStyle = (
  highlight: TrackingHighlight,
): { backgroundColor: string; color: string } | undefined =>
  highlight
    ? {
        backgroundColor: TRACKING_HIGHLIGHT_COLORS[highlight].background,
        color: TRACKING_HIGHLIGHT_COLORS[highlight].foreground,
      }
    : undefined;
